
import { useRef } from 'react';


// eslint-disable-next-line @typescript-eslint/no-explicit-any
function useSingleton<T extends (...args: any) => any>(singletonCreator: T): ReturnType<T> {

  const singletonRef = useRef(null);

  if (!singletonRef.current) {
    singletonRef.current = singletonCreator();
  }

  if (!singletonRef.current) {
    throw Error('Singleton wasn\'t initialized!');
  }

  return singletonRef.current;
}


export default useSingleton;
